import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import { Redirect, Link } from "react-router-dom"
import MetaWhatsAppInbox from "../../components/Admin/MetaWhatsAppInbox"
import { getCurrentUser } from "../../helpers/Utils"
import { isMetaWaDesignDemo } from "../../helpers/metaWhatsAppDesignDemo"

const WhatsappMetaInboxPage = () => {
  const enabled =
    isMetaWaDesignDemo() ||
    getCurrentUser()?.enable_whatsapp_meta_integration === 1 ||
    getCurrentUser()?.enable_whatsapp_meta_integration === "1"

  if (!enabled) {
    return <Redirect to="/settings" />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>WhatsApp Inbox | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
              <div>
                <h4 className="page-title mb-1">WhatsApp Inbox</h4>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <Link to="/connect-whatsapp-meta">WhatsApp Business</Link>
                  </li>
                  <li className="breadcrumb-item active">Inbox</li>
                </ol>
              </div>
              <div className="d-flex gap-2">
                <Link
                  to="/whatsapp-meta-templates"
                  className="btn btn-sm btn-outline-secondary"
                >
                  Templates
                </Link>
                <Link
                  to="/connect-whatsapp-meta"
                  className="btn btn-sm btn-outline-secondary"
                >
                  Connection
                </Link>
              </div>
            </div>
          </div>
          <MetaWhatsAppInbox />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default WhatsappMetaInboxPage
